import React, { useEffect } from "react";
import AppSettings from "../../../Settings/AppSettings";
import Utils from "../../../Common/Utils";

function WorkerInfo(props) {
  var [codeaReviewUrl, setcodeaReviewUrl] = React.useState(null);
  var [loading, setLoading] = React.useState(false);

  function load_frame() {
    setcodeaReviewUrl(null);
    setLoading(true);
    let api_base_url =
      AppSettings.TASKQUEUE_WORKER_INFO_URL + "?" + Utils.generate_guid();
    setcodeaReviewUrl(api_base_url);

    Utils.check_frame_is_loaded("iframe_task_worker_info", setLoadedFlag);
  }

  function setLoadedFlag(res) {
    if (res) setLoading(false);
  }

  useEffect(() => {
    load_frame();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <React.Fragment>
      {loading && (
        <div className="alert alert-primary bg-white small p-2" role="alert">
          <span className="fas fa-circle-notch fa-spin" />
          &nbsp;
          <strong>
            We are generating the infomation for you. Report should be visible
            below when its ready. Please be patient
          </strong>
        </div>
      )}

      <div className="card border-dark mb-3">
        <iframe
          style={{ height: "75vh" }}
          src={codeaReviewUrl}
          id="iframe_task_worker_info"
          title="WorkerInfo"
        ></iframe>
      </div>
    </React.Fragment>
  );
}

export default WorkerInfo;
